import React from 'react';
import { StyledComponentProps, withStyles } from '@material-ui/core';
import { Button as MuiButton } from '@material-ui/core';
import { styles } from './styles';
import { ReactComponent as Ok } from '../../images/icons/ok.svg';
import clsx from 'clsx';

interface IProps extends StyledComponentProps {
    onClick: (evt:any) => any;
    className?: string;
    disabled?: boolean;
    text: string;
}

const ConfirmButton = (props: IProps) => {
    return (<MuiButton
        disabled={props.disabled}
        className={clsx(props.className, props.classes.btnRootWithIcon)}
        onClick={props.onClick}
        variant="contained">
        <div className={props.classes.withLeftIcon}>
            <Ok className={props.classes.buttonItemIcon} />
            {props.text}
        </div>
    </MuiButton>)
}


export default withStyles(styles)(ConfirmButton)